import { render, staticRenderFns } from "./tts.vue?vue&type=template&id=f4c4a8e8&scoped=true&"
import script from "./tts.vue?vue&type=script&lang=js&"
export * from "./tts.vue?vue&type=script&lang=js&"
import style0 from "./tts.vue?vue&type=style&index=0&id=f4c4a8e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c4a8e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextField,VTextarea})
